import type {AIGeneratorState} from 'src/types/ai-generator';


export const RECEIVE_AI_GENERATOR_INFO = 'ai-generator/receive-info';
export const UPDATE_AI_GENERATOR_INFO = 'ai-generator/update-info';
export const RESET_AI_GENERATOR_STATE = 'ai-generator/reset-state';

type AIGeneratorPayload = Partial<AIGeneratorState>;

type RecieveAIGeneratorInfoAction = {
  type: typeof RECEIVE_AI_GENERATOR_INFO;
  payload: AIGeneratorPayload;
};

type UpdateAIGeneratorInfoAction = {
  type: typeof UPDATE_AI_GENERATOR_INFO;
  payload: AIGeneratorPayload;
};

type ResetStateAction = {
  type: typeof RESET_AI_GENERATOR_STATE;
};

export type AIGeneratorAction =
  | RecieveAIGeneratorInfoAction
  | UpdateAIGeneratorInfoAction
  | ResetStateAction;

export const receiveAIGeneratorInfo = (
  payload: AIGeneratorPayload,
): RecieveAIGeneratorInfoAction => ({
  type: RECEIVE_AI_GENERATOR_INFO,
  payload,
});

export const updateAIGeneratorInfo = (
  payload: AIGeneratorPayload,
): UpdateAIGeneratorInfoAction => ({
  type: UPDATE_AI_GENERATOR_INFO,
  payload,
});

export const resetAIGeneratorInfo = (): ResetStateAction => ({
  type: RESET_AI_GENERATOR_STATE,
});
